import * as React from 'react';
import PropTypes from 'prop-types';

const SvgActionsEditNormalXsmall = React.forwardRef(
  ({ color, size, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M14.852 1.4l-.206-.206-1.72-.924-.589.086-8.721 8.72-3.057 5.689.676.676 5.43-2.889 8.969-8.939.088-.589-.87-1.624zM4.1 10.247l1.105.592.56 1.061-3.554 1.889L4.1 10.247zm2.469 1.022l-.552-1.035-.2-.205-1.127-.6 8.1-8.1L14.041 2l.624 1.169-8.096 8.1z"
        fill=""
      />
    </svg>
  )
);
SvgActionsEditNormalXsmall.defaultProps = {
  color: 'currentColor',
  size: 16,
  title: undefined,
  titleId: undefined
};
SvgActionsEditNormalXsmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string,
  titleId: PropTypes.string
};
export default SvgActionsEditNormalXsmall;
